/** Minimal HTML-escaping for the print-window builders in this feature -- every dynamic value (product names, addresses, notes) must be escaped before being concatenated into the print window's HTML string. */
export function escapeHtml(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
